export default __webpack_public_path__ + "static/DMSerifText-Regular-c63bc97c84c421f39c7a3b21a5e243e7.ttf";